<div
  [style.display]="state.tooltipDisplay"
  [style.left.px]="state.tooltipPosition.x"
  [style.top.px]="state.tooltipPosition.y"
  class="gojs-html-info-tooltip"
>
  <div class="tooltip-messages">{{ state.tooltipText }}</div>
</div>

<!-- Context Menu -->
<div
  class="absolute"
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="mainContextMenu"
  [style.left.px]="state.menuPosition.x"
  [style.top.px]="state.menuPosition.y"
></div>

<mat-menu #mainContextMenu="matMenu" class="gojs-html-info-context-menu">
  <ng-container *ngFor="let item of state.menuItems; trackBy: trackByLabel">
    <!-- Handle branch node buttons here -->
    <ng-container *ngIf="!!item.children?.length">
      <button
        mat-menu-item
        [matMenuTriggerFor]="menu.childMenu"
        #subMenuTrigger="matMenuTrigger"
        (mouseover)="subMenuTrigger.openMenu()"
      >
        <y42-icon *ngIf="item.icon" [icon]="item.icon"></y42-icon>
        {{ item.label }}
      </button>
      <y42-gojs-sub-context-menu #menu [items]="item.children"></y42-gojs-sub-context-menu>
    </ng-container>

    <!-- Leaf node buttons here -->
    <ng-container *ngIf="!item.children?.length">
      <button mat-menu-item (click)="item.callback()">
        <y42-icon *ngIf="item.icon" [icon]="item.icon"></y42-icon>
        {{ item.label }}
      </button>
    </ng-container>
  </ng-container>
</mat-menu>
